
<div :class="{ center: center }">
  <button class="button" :disabled="disabled" @click="onClick">
    <slot>Button</slot>
  </button>
</div>
